import { CollapsableAlert } from "@src/appV2/redesign/components/CollapsableAlert";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function getTimesheetReviewAlertContent(params: {
  isShiftVerified: boolean;
  isInstantPay: boolean;
}): { title: string; description: string } {
  const { isShiftVerified, isInstantPay } = params;

  if (isShiftVerified) {
    return {
      title: "You are requesting a shift adjustment",
      description:
        "Your shift adjustment will be reviewed and you\u2019ll receive a response within 3 business days.",
    };
  }

  if (isInstantPay) {
    return {
      title: "Your adjusted time is pending workplace approval.",
      description:
        "Your shift adjustment will be reviewed and you\u2019ll receive a response within 3 business days.",
    };
  }

  return {
    title: "You are requesting a shift payment",
    description:
      "Your shift payment request will be reviewed and you\u2019ll receive a response within 3 business days.",
  };
}

interface TimesheetReviewAlertProps {
  isShiftVerified: boolean;
  isInstantPay: boolean;
}

export function TimesheetReviewAlert(props: TimesheetReviewAlertProps) {
  const { isShiftVerified, isInstantPay } = props;
  const { title, description } = getTimesheetReviewAlertContent({ isShiftVerified, isInstantPay });

  return (
    <CollapsableAlert title={title}>
      <Text variant="body2">{description}</Text>
    </CollapsableAlert>
  );
}
